export default __webpack_public_path__ + "static/media/meal.16ca026e.png";